import styled from 'styled-components'

const PageWrapper = styled.div` 
  display: flex;
  flex-direction: column;
  width: 100%; 
  width: 100%;
  padding: 1.5rem 20px;
  background: #F0F0F5 !important;
  @media (max-width: 415px) {
    width: 98%;
  }
`

export default PageWrapper
